export const cleanTranslations = (translations) => {
    return Object.fromEntries(Object.entries(translations).map(([key, value]) => [key === null || key === void 0 ? void 0 : key.trim(), value === null || value === void 0 ? void 0 : value.trim()]));
};
